export default "__VITE_ASSET__PcpgiqN$__"